import { useEffect, useState } from "react"
import { useRecoilState } from "recoil"

import { dealerInfo } from "../../atoms/DealerAtom"
import LayoutPresetBuilds from "../../containers/PresetBuilds/LayoutPresetBuilds"
import { getApiHelper } from "../../util/apiHelpers"

function DealerBuilds() {
  const [data, setData] = useState([])
  const [dealerInfoValue] = useRecoilState(dealerInfo)
  const getPresets = () => {
    getApiHelper(
      `api/Presets?presetTypeId=3&dealerId=${dealerInfoValue.dealerID}`
    )
      .then((res) => {
        setData(res.data)
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    getPresets()
  }, [])

  return (
    <div>
      <LayoutPresetBuilds nameBuilds="Dealer" data={data} />
    </div>
  )
}

export default DealerBuilds
